"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DepositRoutes = void 0;
const route_1 = require("../route");
class DepositRoutes extends route_1.Route {
    constructor() {
        super('deposits');
    }
    deposit(amount, linkedAccountId, metadata) {
        return this.post('/', { amount, linkedAccountId, metadata });
    }
    getDeposit(id) {
        return this.get(`/${id}`);
    }
}
exports.DepositRoutes = DepositRoutes;
//# sourceMappingURL=deposits.js.map